import React, { useContext } from "react";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import FastbetCartContext from "../../data/fastbet/FastbetCartContext";
import Img from "../Img";
import { classIf, formatDate, getConfiguration, oddToString } from "../../data/utils";
import { getLabel } from "../../InitData";

export default function CouponEvent(props) {
    const betslipContext = useContext(BetslipContext) ;
	const betslipData = betslipContext.getBetslipData();
	const fastbetContext = useContext(FastbetCartContext);
	// const liveContext = useContext(LiveContext);
	// const mainContext = useContext(MainContext);
	const couponKey = props.couponKey;
	const conf = getConfiguration();
	const bankerEnabled = conf.sybe != null? conf.sybe : true;
	const showSelectionTimestamp = conf?.sbst;
    let alias = props.selection.alias;
    alias = alias == null? '' : alias + ' ';
    const container = props.container;
    let tabSingle = container === 'singlebets';
    let tabMulti = container === 'multibets';
    
    let event = props.selection;
	let eventTimestamp;

	if (showSelectionTimestamp)  {
		try {
			eventTimestamp = event.timestamp && formatDate(event.timestamp).formatted;
		} catch(err) {
			console.log(err);
		}
	}

    
    let descSportTournament = null;
    if (props.selection.descSport != null && props.selection.descSport.length > 0) {
    	descSportTournament = props.selection.descSport;
    }
    
    if (props.selection.descTournament != null && props.selection.descTournament.length > 0) {
    	if (descSportTournament == null) {
    		descSportTournament = "";
    	}
    	else{
    		descSportTournament = descSportTournament + " - ";
    	}
    	descSportTournament =  descSportTournament + props.selection.descTournament;
    }
    
    let homeTeam = event.descEvent.split(" - ")[0];
    let awayTeam = event.descEvent.split(" - ")[1];
    
    let bets = event.bets;
    // restoring the bets array: if it is not a systembet, then I will draw just the first bet
    if (container != 'systembets' && !betslipContext.isBetBuilder()) {
    	let aux = [];    
    	if (bets.length > 0) {
    		aux.push(bets[0]);
    	}
    	bets = aux;
    }
    
    let idElement = "bet-event-coupon-" + couponKey + "-container-" + container + "-pal-" + event.pal + "-avv-" + event.avv;
    idElement = idElement + (tabSingle? "-for-bet-" + (bets[0].scomSogei + "-" + bets[0].handicap + "-" + bets[0].draw ) : "");
    function deleteSelection(scomSogei, handicap, codDraw, removeAllBets){
    	if (removeAllBets) {
    		scomSogei = null;
    		codDraw = null;
    		handicap = null;
    	}
    	betslipContext.toggleSelectionBetslip(event.pal, event.avv, null, null, null, scomSogei, handicap, null, codDraw, null, null);
    }
    
    function toggleBanker() {
    	if (bankerEnabled) {
			betslipContext.toggleBanker(event.pal, event.avv);
    	}

    }
    
    let blinkElement = false;
    if (event.closed == null || event.closed == false) {
    	for(let km in event.bets){
    		blinkElement = blinkElement || (event.bets[km].updated != null || event.bets[km].closed); 
    	}
    } else {
    	blinkElement = true;
    }

    return <div className={`b_16${classIf(blinkElement, 'blink')}`}>
            <div className="b_16_1">
                <div className="b_16_1_1">
                    {event.closed != null && event.closed &&
                        <Img className="b_16_1_1_1" src="icon_caution_my_account.svg" height="12px" width="12px" />
                    }
                    <div className="b_16_1_1_2">{`${homeTeam}${awayTeam ? ` - ${awayTeam}` : ''}`}</div>
                </div>
                <div className="b_16_1_2">
                    {event.isLive ?
                        <div className="b_18">Live</div>
                        :
                        <div className="b_16_1_2_1">{alias}</div>
                    }
                </div>
            </div>
            {bets.map(function(bet) {
                const reactKey =  `key bet-draw-sel-${couponKey}-container-${container}-pal-${event.pal}-avv-${event.avv}-scom-${bet.scomSogei}_${bet.handicap}-draw-${bet.draw}`;
                
                let playabilityIssue = null;
                if (container === 'multibets' && (bet.minPlError || bet.maxPlError) ) {
                    let minPl = bet.minPl? bet.minPl : 1;
                    let maxPl = bet.maxPl? bet.maxPl : (conf.meb? conf.meb:30);
                    if (minPl > 1) {
                        minPl --;
                    }
                    if (maxPl > 1) {
                        maxPl --;										
                    }
                    playabilityIssue = getLabel('playability.min_max_issue');
                    playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
                    playabilityIssue = playabilityIssue.replaceAll('{{MAX_SEL}}', maxPl);
                }
                if (container === 'multibets' && !playabilityIssue && bet.minOddError) {
                    playabilityIssue = getLabel('playability.min_odd_issue');
                    playabilityIssue = playabilityIssue.replaceAll('{{MIN_ODD}}', oddToString(bet.minOddError));
                }
                
                if (container === 'singlebets' && bet.minPlError) {
                    let minPl = bet.minPl? bet.minPl : 1;
                    if (minPl > 1) {
                        minPl --;
                    }
                    playabilityIssue = getLabel('playability.min_issue');
                    playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
                }

                return (
                    <React.Fragment key={reactKey}>
                        <div className="b_16_2">{bet.descBet}</div>
                        <div className="b_16_3">
                            <div className="b_16_3_1">
                                <div className="b_16_3_1_1">
                                    {container === 'systembets' && bankerEnabled &&
                                        <div className={"b_16_3_1_1_1" + classIf(event.banker, 'active')} onClick={toggleBanker}>FIX</div>
                                    }
                                    <div className="b_16_3_1_1_2">{bet.descDraw}</div>
                                </div>
                            </div>
                            <div className="b_16_3_2">
                                <div className="b_16_3_2_1">{oddToString(bet.odd)}</div>
	            				{
	            					bet.updated &&
	            					<Img className="b_14_2_3" src={bet.updated === 'increased'? "icon_raise_odd.svg" : "icon_drop_odd.svg"} height="12px" width="12px" />
	            				}
                                <Img className="b_16_3_2_2" src="icon_delete_event.svg" height="18px" width="18px" onClick={() => deleteSelection(bet.scomSogei, bet.handicap, bet.draw, false)} />
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
   </div>

}
